import { Component, ViewChild } from '@angular/core';
import {
  AppTableComponent,
  ProcurementCategoriesService,
  ProcurementCategoryModel,
  SearchModel,
  SearchResultModel,
  TranslationManager,
} from 'src/common';

@Component({
  selector: 'procurement-category-select',
  templateUrl: './procurement-category-select.component.html',
})
export class ProcurementCategorySelectComponent {
  constructor(
    private procurementCategoriesService: ProcurementCategoriesService
  ) { }

  @ViewChild('table') table: AppTableComponent;
  translationManager = TranslationManager;
  selectedId: number;
  procurementCategories: any[];
  show: boolean = false;
  resolve: any;

  showModal(id:number=undefined): Promise<number> {
    this.show = true;
    this.selectedId=id;

    this.table.onSearch = this.doSearch.bind(this);
    this.table.search();

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  doSearch(search: SearchModel) {
    this.procurementCategoriesService
      .searchProcurementCategories(search)
      .then((result: SearchResultModel<ProcurementCategoryModel>) => {
        this.procurementCategories = result.items;
        this.table.setTotalCount(result.totalCount);
      });
  }

  selectProcurementCategory(id: number,event) {
    this.selectedId = event.target.checked?id:-1;
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve();
    }
  }

  submit() {
    this.show = false;
    if (this.resolve) {
      this.resolve(this.selectedId);
    }
  }
}
